import { gql } from "@apollo/client";

export default gql`
  fragment nftInfo on NftType {
    id
    cid
    owner
  }
`;
